import SelectCard from './SelectCard'
import { MultiSelectorOption } from '../../interfaces/multi-selector-option'
import React from 'react'

interface MultiselectorProps {
  setSelectedValues: (values: string[]) => void
  selectedValues: string[]
  options: MultiSelectorOption[]
  label: string
  disabled?: boolean
}

const MultiSelector = ({
  setSelectedValues,
  selectedValues,
  options,
  label,
  disabled,
}: MultiselectorProps) => {
  const [selectedPermissions, setSelectedPermissions] = React.useState<
    MultiSelectorOption[]
  >([])

  const [searchKey, setSearchKey] = React.useState('')

  React.useEffect(() => {
    // if selectedValues
    if (selectedValues && selectedValues.length) {
      setSelectedPermissions(
        options.filter((option) => {
          return selectedValues.includes(option.value)
        })
      )
    }
  }, [options, selectedValues])

  const handlePermSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKey(e.target.value)
  }

  const handlePermSelect = (perm: MultiSelectorOption) => {
    // check if perm has been added
    const permAdded = selectedPermissions.some((sp) => {
      return sp.value === perm.value
    })

    if (!permAdded) {
      const sPSelection = [...selectedPermissions, perm]
      setSelectedPermissions(sPSelection)
      const selectedPermIds = sPSelection.map((sP) => sP.value)

      if (selectedPermIds.length) {
        setSelectedValues(selectedPermIds)
      }
    }
    setSearchKey('')
  }

  const handlePermRemove = (perm: MultiSelectorOption) => {
    const filteredPerm = selectedPermissions.filter((sp) => sp.value !== perm.value);
    setSelectedPermissions(filteredPerm);
  
    // Update formik's permissions array
    const updatedValues = filteredPerm.map((sP) => sP.value);
    setSelectedValues(updatedValues);
  };
  
  return (
    <div className="grid gap-5">
      <div className="grid gap-2.5">
        <p>{label}</p>
        <div className="flex border p-2 gap-4 flex-wrap">
          {selectedPermissions.map((perm) => {
            return (
              <SelectCard
                key={perm.value}
                title={perm.name}
                description={perm.description}
                showRemove
                removeFn={() => {
                  !disabled && handlePermRemove(perm)
                }}
              />
            )
          })}
          <input
            className="grow bg-transparent"
            onChange={handlePermSearch}
            value={searchKey}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="grid gap-2.5">
        {searchKey ? (
          <>
            <p>Suggestions</p>
            <div className="flex overflow-x-scroll p-5 gap-4 border">
              {options
                .filter((perm) => {
                  return (
                    (perm.name.includes(searchKey) ||
                      perm.description.includes(searchKey)) &&
                    !selectedValues.includes(perm.value)
                  )
                })
                .map((perm) => {
                  return (
                    <SelectCard
                      key={perm.value}
                      title={perm.name}
                      description={perm.description}
                      addFn={() => {
                        !disabled && handlePermSelect(perm)
                      }}
                    />
                  )
                })}
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default MultiSelector
